<template>
    <Toast />
    <TelegramConnect />
    <CookiePolicyComponent />
    <div
        ref="container"
        class="menu_top__container flex w-full justify-content-between column-gap-3"
        :class="{
            menu_top__container_left: isLeftMenu,
            'flex-wrap xl:flex-nowrap': isLeftMenu,
            'flex-nowrap': !isLeftMenu,
        }"
    >
        <div class="menu_top__logo flex align-items-center gap-2 flex-order-1">
            <Button
                v-if="!disableLeftMenu && isNotebook"
                icon="pi pi-bars"
                text
                class="header_top__menu_button -ml-2"
                @click="onClickMobileMenu"
            />
            <a :href="getLink('/')" :title="$t('lang.main.menu_top.main')">
                <img :src="getLogoLink" :alt="$t('lang.main.menu_top.main')" />
            </a>
        </div>

        <!-- меню для авторизованных пользователей с включенным левым меню -->
        <template v-if="isUserAuthenticated && isLeftMenu">
            <!-- и слотом search, без него ничего не выводим -->
            <div
                v-if="$slots.search().length"
                class="menu_top__search flex w-full xl:w-auto flex-order-4 xl:flex-order-2 flex-grow-1 pt-3 xl:pt-0"
            >
                <slot name="search"></slot>
            </div>
        </template>
        <!-- меню для авторизованных пользователей с выключенным левым меню -->
        <template v-else-if="isUserAuthenticated && !isLeftMenu">
            <div class="hidden lg:flex align-items-center w-full lg:w-auto flex-order-4 lg:flex-order-3 menu_top__menu gap-3 my-2">
                <a :href="getLink('/projects')">
                    <span>{{ $t('lang.menu.projects') }}</span>
                </a>
                <a @click.prevent @mouseenter="onHoverSites" class="cursor-default">
                    <span>{{ $t('lang.menu.sites_label') }}</span>
                    <i class="fa fa-caret-down"></i>
                </a>
                <a @click.prevent @mouseenter="onHoverLinks" class="cursor-default">
                    <span>{{ $t('lang.menu.links_label') }}</span>
                    <i class="fa fa-caret-down"></i>
                </a>
                <a @click.prevent @mouseenter="onHoverKeywords" class="hidden md:flex cursor-default">
                    <span>{{ $t('lang.menu.keywords_label') }}</span>
                    <i class="fa fa-caret-down"></i>
                </a>
                <a :href="getLink('/clustering-list')" class="hidden md:flex">
                    <span>{{ $t('lang.menu.clustering_list') }}</span>
                </a>
                <a @click.prevent class="hidden xl:flex cursor-default" @mouseenter="onHoverAds">
                    <span>{{ $t('lang.menu.ads_label') }}</span>
                    <i class="fa fa-caret-down"></i>
                </a>
                <a :href="getLink('/monitoring-list')" class="menu_top__more_hidden">
                    <span>{{ $t('lang.menu.monitoring_list') }}</span>
                </a>
                <a :href="getLink('/ai-tracker-list')" class="menu_top__more_hidden top_menu__item_new">
                    <span>{{ $t('lang.menu.ai_tracker') }}</span>
                </a>
                <a @click.prevent class="menu_top__more_button cursor-default" @mouseenter="onHoverMore">
                    <i class="pi pi-ellipsis-h"></i>
                </a>
            </div>
        </template>
        <!-- меню для неавторизованных пользователей -->
        <div
            v-else
            class="flex align-items-center flex-order-4 lg:flex-order-3 menu_top__menu gap-3 my-2 menu_top__guest"
        >
            <a :href="getLink('')" class="text-center">
                <span>{{ $t('lang.menu.guest.site') }}</span>
            </a>
            <a :href="getLink('/links')" class="text-center">
                <span>{{ $t('lang.menu.guest.links') }}</span>
            </a>
            <a :href="getLink('/monitoring')" class="text-center">
                <span>{{ $t('lang.menu.guest.monitoring') }}</span>
            </a>
            <a :href="getLink('/wordstat')" class="hidden xl:flex text-center">
                <span>{{ $t('lang.menu.guest.wordstat') }}</span>
            </a>
            <a :href="getLink('/clustering')" class="hidden xl:flex text-center">
                <span>{{ $t('lang.menu.guest.clustering') }}</span>
            </a>
            <a :href="getLink('/ai-tracker')" class="hidden 2xl:flex text-center top_menu__item_new">
                <span>{{ $t('lang.menu.guest.ai_tracker') }}</span>
            </a>
            <a @click.prevent class="flex cursor-default" @mouseenter="onHoverGuestMore">
                <i class="pi pi-ellipsis-h"></i>
            </a>
        </div>

        <div class="menu_top__menu mr-2 flex gap-3 flex-grow-1 flex-order-3 justify-content-end align-items-center">
            <a
                :href="getLink('/tarif')"
                :class="{'hidden md:flex': isUserAuthenticated}"
                :title="$t('lang.menu.tariff')"
            >
                <i class="ksi ksi-tarif"></i>
                <span class="menu_top__menu_text hidden sm:inline">{{ $t('lang.menu.tariff') }}</span>
            </a>
            <a
                class="hidden md:flex"
                :title="$t('lang.menu.help_label')"
                @click.prevent
                @mouseenter="onHoverHelp"
            >
                <i class="ksi ksi-help-main"></i>
                <span class="menu_top__menu_text hidden sm:inline lg:hidden xl:inline">{{ $t('lang.menu.help_label') }}</span>
                <i class="fa fa-caret-down"></i>
            </a>
            <a
                :href="getLink('/system-notifications')"
                @mouseenter="onHoverSystemNotifications"
                v-badge="systemNotifications.count"
                class="menu_top__system_notifications"
                :title="isMobile ? $t('lang.menu.system_notifications') : ''"
            >
                <i class="ksi ksi-bell-main"></i>
            </a>
            <template v-if="isUserAuthenticated">
                <a @click.prevent @mouseenter="onHoverUser">
                    <i class="ksi ksi-user-main"></i>
                    <span class="menu_top__menu_text hidden sm:inline lg:hidden xl:inline">{{ getCurrentUser.email }}</span>
                    <i class="fa fa-caret-down"></i>
                </a>
            </template>
            <template v-else>
                <a :href="getLink('/login')" :title="isNotebook ? $t('lang.menu.login') : ''">
                    <i class="ksi ksi-login"></i>
                    <span class="hidden lg:inline">{{ $t('lang.menu.login') }}</span>
                </a>
                <a :href="getLink('/registration')" :title="isNotebook ? $t('lang.menu.register') : ''">
                    <i class="ksi ksi-register"></i>
                    <span class="hidden lg:inline">{{ $t('lang.menu.register') }}</span>
                </a>
            </template>
        </div>
        <MenuSubmenuTopHelp />
        <MenuSystemNotifications
            v-model:count="systemNotifications.count"
            :items="systemNotifications.items"
            @onMarkSingle="this.onMarkSingle"
            @onMarkAll="this.onMarkAll"
        />
        <template v-if="isUserAuthenticated">
            <MenuSubmenuTopUser :email="getCurrentUser.email" :isLeftMenu="isLeftMenu"/>
            <MenuSubmenuTopSites />
            <MenuSubmenuTopLinks />
            <MenuSubmenuTopKeywords />
            <MenuSubmenuTopAds />
            <MenuSubmenuTopMore />
        </template>
        <template v-else>
            <MenuSubmenuTopGuestMore />
        </template>
    </div>
    <div
        v-if="!isLeftMenu && isUserAuthenticated && $slots.search().length"
        class=" menu_top__search_container flex align-items-center p-3"
    >
        <slot name="search"></slot>
    </div>
    <template v-if="!isLeftMenu && isNotebook">
        <MenuMobile
            :favorite-items="favoriteItems"
            :isUserAuth="isUserAuthenticated"
            :isLeftMenu="isLeftMenu"
        />
        <MenuSettings />
    </template>
</template>

<script>
import Button from "primevue/button";
import {Listeners} from "../../constants/listeners";
import SystemNotificationsApi from "../../api/SystemNotificationsApi";
import Alerts from "../../mixins/Alerts";
import MenuSystemNotifications from "./component/SystemNotifications.vue";
import WindowResize from "../../mixins/WindowResize";
import MenuSubmenuTopUser from "./component/SubmenuTopUser.vue";
import MenuSubmenuTopHelp from "./component/SubmenuTopHelp.vue";
import MenuSubmenuTopSites from "./component/SubmenuTopSites.vue";
import MenuSubmenuTopLinks from "./component/SubmenuTopLinks.vue";
import MenuSubmenuTopKeywords from "./component/SubmenuTopKeywords.vue";
import MenuSubmenuTopAds from "./component/SubmenuTopAds.vue";
import MenuSubmenuTopMore from "./component/SubmenuTopMore.vue";
import MenuSubmenuTopGuestMore from "./component/SubmenuTopGuestMore.vue";
import TelegramConnect from "../common/TelegramConnect.vue";
import CookiePolicyComponent from "../CookiePolicy.vue";
import Toast from "primevue/toast";
import BrowserStorage from "../../mixins/BrowserStorage";
import {StorageKeys} from "../../constants/storageKeys";
import {nextTick} from "vue";
import MenuMobile from "./component/Mobile.vue";
import MenuSettings from "./component/Settings.vue";

export default {
    name: "MenuTop",
    mixins: [Alerts, WindowResize, BrowserStorage],
    props: {
        disableLeftMenu: {
            type: Boolean,
            required: false,
            default: false,
        },
        isUserAuthenticated: {
            type: Boolean,
            required: true,
        },
        isLeftMenu: {
            type: Boolean,
            required: true,
        },
        favoriteItems: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            model: {
                leftMenuCollapse: true,
            },
            systemNotifications: {
                count: 0,
                items: [],
            },
            containerHeight: null,
        }
    },
    created() {
        window.addEventListener('resize', this.setContainerHeight);
    },
    mounted() {
        this.model.leftMenuCollapse = this.getLocalStorageItem(StorageKeys.LEFT_MENU_COLLAPSE) ?? false;
        this.onLoadSystemNotifications();
        this.$emitter.on(Listeners.LEFT_MENU_CLICK, this.onClickMenu);
        this.syncViewportAndHeight();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.setContainerHeight);
    },
    computed: {
        getVisibilitySystemNotificationsBadge() {
            return this.systemNotifications.count > 0 ? '1' : '0';
        },
        getCurrentUser() {
            return this.$store.getters.USER;
        },
        getMinWidthLogo() {
            if (!this.isLeftMenu) {
                return '100px';
            }
            // на таблетах или схлопнутом меню
            if (this.isTablet || this.model.leftMenuCollapse) {
                return '166px';
            }

            // при развернутом меню, чтобы было выровнено по контенту
            return '224px';
        },
        getLogoLink() {
            let date = new Date()
            if ((new Date('2025-11-11T00:00:00+03:00')) < date && date < (new Date('2025-11-14T00:00:00+03:00'))) {
                return '/i/icons/keys11_logo.svg'
            }
            return '/i/icons/logo-light.svg';
        },
    },
    methods: {
        onHoverSystemNotifications(event) {
            if (this.isMobile || !this.isUserAuthenticated) {
                return;
            }

            this.$emitter.emit(Listeners.TOP_MENU_SYSTEM_NOTIFICATIONS_HOVER, event);
        },
        getLink(page) {
            return sprintf('/%s%s', window.locale, page);
        },
        onClickMenu() {
            if (this.isTablet) {
                return;
            }

            this.model.leftMenuCollapse = !this.model.leftMenuCollapse;
        },
        onClickMobileMenu() {
            this.$emitter.emit(Listeners.LEFT_MENU_MOBILE_TOGGLE);
        },
        onLoadSystemNotifications() {
            SystemNotificationsApi
                .get()
                .then(response => this.systemNotifications = response)
                .catch(error => this.alertError(error));
        },
        onMarkSingle(data) {
            this.systemNotifications.count--;
            this.systemNotifications.items.splice(data.index, 1);

            SystemNotificationsApi
                .markRead(data.id)
                .then(this.onLoadSystemNotifications)
                .catch(error => this.alertError(error));
        },
        onMarkAll() {
            this.systemNotifications = {
                count: 0,
                items: [],
            };

            SystemNotificationsApi
                .markAllRead()
                .catch(error => this.alertError(error));
        },
        onHoverUser(event) {
            this.$emitter.emit(Listeners.TOP_MENU_TOP_USER_HOVER, event);
        },
        onHoverHelp(event) {
            this.$emitter.emit(Listeners.TOP_MENU_TOP_HELP_HOVER, event);
        },
        onHoverSites(event) {
            this.$emitter.emit(Listeners.TOP_MENU_TOP_SITES_HOVER, event);
        },
        onHoverLinks(event) {
            this.$emitter.emit(Listeners.TOP_MENU_TOP_LINKS_HOVER, event);
        },
        onHoverKeywords(event) {
            this.$emitter.emit(Listeners.TOP_MENU_TOP_KEYWORDS_HOVER, event);
        },
        onHoverAds(event) {
            this.$emitter.emit(Listeners.TOP_MENU_TOP_ADS_HOVER, event);
        },
        onHoverMore(event) {
            this.$emitter.emit(Listeners.TOP_MENU_TOP_MORE_HOVER, event);
        },
        onHoverGuestMore(event) {
            this.$emitter.emit(Listeners.TOP_MENU_TOP_GUEST_MORE_HOVER, event);
        },
        syncViewportAndHeight() {
            this.onWindowResize();
            this.setContainerHeight();
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    this.onWindowResize();
                    this.setContainerHeight();
                });
            });
        },
        setContainerHeight() {
            nextTick(() => {
                requestAnimationFrame(() => {
                    const container = this.$refs.container;
                    if (!container) {
                        return;
                    }
                    this.containerHeight = container.offsetHeight;
                });
            });
        },
    },
    watch: {
        innerWidth() {
            this.setContainerHeight();
        },
        isNotebook() {
            this.setContainerHeight();
        },
        containerHeight() {
            // обновляем значение css переменной --keysso-top-menu-height
            document.documentElement.style.setProperty(
                '--keysso-top-menu-height',
                sprintf('%dpx', this.containerHeight)
            );
        },
    },
    components: {
        MenuSettings,
        Toast,
        CookiePolicyComponent,
        TelegramConnect,
        MenuSubmenuTopHelp,
        MenuSubmenuTopUser,
        MenuSubmenuTopSites,
        MenuSubmenuTopLinks,
        MenuSubmenuTopKeywords,
        MenuSubmenuTopAds,
        MenuSubmenuTopMore,
        MenuSubmenuTopGuestMore,
        MenuSystemNotifications,
        Button,
        MenuMobile,
    },
}
</script>

<style scoped>
.menu_top__container {
    position: sticky;
    top: 0;
    z-index: var(--keysso-zindex-top-menu);
    min-height: 60px;
    background-color: #33404D;
    align-items: center;
    padding: 8px 16px;
}
.menu_top__container_left {
    padding: 8px 10px;
}
.menu_top__logo {
    display: flex;
    align-items: center;
    column-gap: 8px;
    min-width: v-bind(getMinWidthLogo);
}
:deep(.header_top__menu_button) {
    color: #fff;
}
.menu_top__menu > a {
    display: flex;
    align-items: center;
    column-gap: 6px;
    font-size: 13px;
    color: #fff;
    text-decoration: none;
    padding: 3px 0;
    margin-left: 12px;
}
.menu_top__menu > a > i.ksi {
    font-size: 24px;
}
:deep(.menu_top__system_notifications) .p-badge {
    right: 1px;
    top: 3px;
    border-radius: 50%;
    min-width: 14px;
    width: 14px;
    min-height: 14px;
    height: 14px;
    padding: 0;
    font-size: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: v-bind(getVisibilitySystemNotificationsBadge);
}
.menu_top__search_container {
    background-color: #232D35;
}
@media (min-width: 1200px) and (max-width: 1500px) {
    .menu_top__menu_text {
        display: none !important;
    }
}

/* оформление указателей new, beta */
.top_menu__item_new,
.top_menu__item_beta {
    position: relative;
}
.top_menu__item_new:after,
.top_menu__item_beta:after {
    position: absolute;
    left: calc(100% + 4px);
    bottom: calc(100% - 11px);
    border-radius: 2px;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .1px;
    line-height: 1;
    padding: 1px 4px;
}
.top_menu__item_new:after {
    content: 'новое';
    background-color: #70b319;
}
.top_menu__item_beta:after {
    content: 'бета';
    background: orange;
}
.menu_top__guest {
    display: none;
    flex-shrink: 0;
}
@media (min-width: 992px) {
    .menu_top__guest {
        display: flex;
    }
}
.menu_top__guest .top_menu__item_new:after,
.menu_top__guest .top_menu__item_beta:after {
    position: static;
}

.menu_top__more_hidden {
    display: flex !important;
}
.menu_top__more_button {
    display: none !important;
}
@media (max-width: 1260px) {
    .menu_top__more_hidden {
        display: none !important;
    }
    .menu_top__more_button {
        display: flex !important;
    }
}
</style>
